import { Outlet, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { colors } from "src/styles/theme";
import Button from "../Button";
import { FaArrowLeft } from "react-icons/fa6";
import { useCloseBrowser } from "src/hooks/useCloseBrowser";
type ServiceCategory = "year" | "event";
export default function MainLayout(props: { serviceCotegory: ServiceCategory }) {
  return (
    <Contianer>
      <Header serviceCotegory={props.serviceCotegory} />
      <OutletCover className="page-default">
        <Outlet />
      </OutletCover>
    </Contianer>
  );
}

const HeaderContents: { [key in ServiceCategory]: string } = {
  event: "월 단체(행사)",
  year: " 연 단체 ",
};

const Header = (props: { serviceCotegory: ServiceCategory }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const closeBrowser = useCloseBrowser();

  return (
    <StyledHeader className="header-height">
      {pathname === "/year-booking" || pathname === "/event-booking" ? (
        <LeftIconButton
          key={window.location.href + window.location.search}
          $colorTheme="white"
          onClick={() => closeBrowser("exit")}
        >
          <FaArrowLeft size={"20px"} fontWeight={"normal"} />
        </LeftIconButton>
      ) : (
        <LeftIconButton
          key={window.location.href + window.location.search}
          id={`${pathname}-${Date.now()}`}
          $colorTheme="white"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft size={"20px"} fontWeight={"normal"} />
        </LeftIconButton>
      )}
      <CenterTitle>{HeaderContents[props.serviceCotegory]}</CenterTitle>
      <AbsoluteButton $colorTheme="white" onClick={() => navigate("/year-booking/lan")}>
        <FontColor>이용안내</FontColor>
      </AbsoluteButton>
    </StyledHeader>
  );
};
const OutletCover = styled.div`
  overflow: auto;
  width: 100%;
`;

const Contianer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
`;
const StyledHeader = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid ${colors.gray.second};
  position: relative;
  height: 60px;
`;

const CenterTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;

const LeftIconButton = styled(Button)`
  position: absolute;
  left: 10px;
`;

const AbsoluteButton = styled(Button)`
  position: absolute;
  right: 10px;
`;

const FontColor = styled.div`
  color: #1a1a1a;
  font-weight: 500;
`;
